import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementBookingsValidateIndexScene from 'scenes/management/bookings_validate'
import ManagementBookingsValidateViewScene from 'scenes/management/bookings_validate/view'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_BOOKINGS_VALIDATE]: {
		component: ManagementBookingsValidateIndexScene,
	},
	[AppRoutes.MANAGEMENT_BOOKINGS_VALIDATE_INDEX]: {
		component: ManagementBookingsValidateViewScene,
	},
}

const ManagementBookingsValidateNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementBookingsValidateNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementBookingsValidateNavigator
